import { featureFactory } from 'features';

import { AccessFeatureDeepKeys } from './featureAccess.types';

type featureContext = {
  causeId?: string;
};

const {
  IfFeatureState: IFFeatureAccess,
  FeatureProvider: FeatureAccessProvider,
  useFeatureFlag: useFeatureAccess,
  useFeaturesContext: useFeatureAccessContext,
} = featureFactory<AccessFeatureDeepKeys, featureContext>();

export { FeatureAccessProvider, IFFeatureAccess, useFeatureAccess, useFeatureAccessContext };
